var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating4Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312f2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9210",
    "data-name": "Group 9210",
    transform: "translate(-3531 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3531 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3534 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9174",
    "data-name": "Group 9174",
    transform: "translate(3549.931 10390.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8891",
    "data-name": "Path 8891",
    d: "M1293.042,22.936a5.992,5.992,0,1,1-5.992-5.992,5.992,5.992,0,0,1,5.992,5.992",
    transform: "translate(-1281.058 -16.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8892",
    "data-name": "Path 8892",
    d: "M1407.234,22.936a5.992,5.992,0,1,0,5.992-5.992,5.992,5.992,0,0,0-5.992,5.992",
    transform: "translate(-1382.205 -16.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8893",
    "data-name": "Path 8893",
    d: "M1325.848,126.657a14.391,14.391,0,0,1-11.745-6.294,1.693,1.693,0,0,1,2.868-1.8,10.96,10.96,0,0,0,8.877,4.708,11.356,11.356,0,0,0,8.891-4.731,1.693,1.693,0,1,1,2.836,1.851,14.728,14.728,0,0,1-11.727,6.266",
    transform: "translate(-1307.341 -97.772)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating4Dark);
export default __webpack_public_path__ + "static/media/rating_4_dark.7df1ba227d2f5abe0ccbfea3f0b8b609.svg";
export { ForwardRef as ReactComponent };